module.exports = __webpack_public_path__ + "img/Apoptosis-PRCA_10X_ANS.07555dda.png";